import FORMFIELD, { LABEL } from '../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import TEXTAREA from '../../../../../../DOM/form/fieldset/field/textarea/TEXTAREA.js';
import { textAttr, textData, textModel } from '../../../../../../DOM/text/TEXT.js';
import CITE from '../../../../../../DOM/cite/CITE.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../DOM/form/label/LABEL.js';
import { fieldModel } from '../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../DOM/span/SPAN.js';
// Model Structure
export const formTextAreaAttr = makeAttrStruct([
    ['class']
]);
export const formTextAreaData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formTextAreaModel = makeStruct([
    ['attributes', formTextAreaAttr],
    ['data', formTextAreaData]
]);
// Simplified Model
export function formTextarea(label, field, message, className) {
    return {
        attributes: formTextAreaAttr(className),
        data: formTextAreaData(label, field, message)
    };
}
/** A Text Area Form Field */
export default class FORMTEXTAREA extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
        this.addClass('form-input');
        this.cite = new CITE(this, textModel(textAttr(), textData('0/' + model.data.field.attributes.maxLength)));
        this.field.on('keyup', () => {
            let charCount = String(this.getValue()).length;
            this.cite.setInnerHTML(charCount + '/' + model.data.field.attributes.maxLength);
        });
    }
    createField(model) {
        return new TEXTAREA(this, model);
    }
}
export { LABEL, TEXTAREA, CITE };
